module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_10.324686c8.jpg";